import api from "../../../app/api";

export type ActivityLogListItem = {
  id: number;
  user: string;
  description: string;
  ip_address: string;
  created_at: string;
  related_table: string;
  related_id: number;
  related_row: string;
};
export type ActivityLogFormItem = {} & ActivityLogListItem;

export function getActivityLogService() {
  return api.getService<ActivityLogFormItem, ActivityLogListItem>(
    "activity-log",
    {
      itemExporter: item => {
        return {ActivityLogForm: item};
      },
    }
  );
}